import * as FC from "@fluentui/react-components";
import { useContext, useState, useEffect } from "react";
import { Context } from "./context";
import { useNavigate } from "react-router-dom";
import { loginUser, useLogin } from "./services/login";

const useStyles = FC.makeStyles({
    root: {
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "end",
        paddingRight: "20%",
        alignItems: "center",
    },
    card: {
        width: "420px",
        boxShadow: FC.tokens.shadow28,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        ...FC.shorthands.padding("10px"),
        ...FC.shorthands.gap("10px"),
    },
});

export const Login = () => {
    let [userInfo, setUserInfo] = useState({ account: "", password: "" });
    let [loading, setLoading] = useState(false);
    let [error, setError] = useState("");
    let nav = useNavigate();
    let { setUser } = useContext(Context);
    let { isAuthenticated } = useLogin();

    // Redirect if already authenticated
    useEffect(() => {
        if (isAuthenticated()) {
            nav("/");
        }
    }, [isAuthenticated, nav]);

    const updateUserInfo = (key) => {
        return (evt) => {
            setError(""); // Clear any previous errors
            let kv = {};
            kv[key] = evt.target.value;
            setUserInfo({ ...userInfo, ...kv });
        };
    };

    const doLogin = async (e) => {
        if (e) {
            e.preventDefault();
        }
        
        if (!userInfo.account || !userInfo.password) {
            setError("请输入用户名和密码");
            return;
        }
        
        setLoading(true);
        setError("");
        
        try {
            let user = await loginUser(userInfo);
            if (user) {
                setUser(user);
                nav("/");
            } else {
                setError("登录失败，请检查用户名和密码");
            }
        } catch (e) {
            console.error("failed to get user info", e);
            setError(e.message || "登录错误，请重试");
        } finally {
            setLoading(false);
        }
    };

    let styles = useStyles();

    return (
        <div
            className={styles.root}
            style={{
                backgroundImage: "url(/background.jpeg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}
        >
            <div className={FC.mergeClasses(styles.card, "bg-[#005A9E0F]")}>
                <form onSubmit={doLogin}>
                    <div className="text-white text-xl font-bold center text-right mr-4 mt-2">
                        {process.env.REACT_APP_APP_NAME || "风电叶片外部巡检数据平台"}
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 20,
                            padding: 20,
                        }}
                    >
                        <div
                            className="px-4"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRight:
                                    "1px solid rgba(255, 255, 255, 0.2)",
                            }}
                        >
                            <img
                                src="/bowongtec-logo.png"
                                alt="上海伯望 Logo"
                                style={{ width: 120 }}
                            />
                        </div>
                        <div
                            style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                                pad: 10,
                            }}
                        >
                            <FC.Label style={{ color: "#fff" }}>
                                用户名
                            </FC.Label>
                            <FC.Input
                                value={userInfo.account}
                                onChange={updateUserInfo("account")}
                                disabled={loading}
                                placeholder="请输入用户名"
                            />
                            <FC.Label style={{ color: "#fff" }}>密码</FC.Label>
                            <FC.Input
                                value={userInfo.password}
                                type="password"
                                onChange={updateUserInfo("password")}
                                disabled={loading}
                                placeholder="请输入密码"
                            />
                            {error && (
                                <div style={{ color: "#ff4444", fontSize: "14px" }}>
                                    {error}
                                </div>
                            )}
                            <FC.Button
                                disabled={
                                    !userInfo.account ||
                                    !userInfo.password ||
                                    loading
                                }
                                appearance="primary"
                                style={{ backgroundColor: "#0078D4" }}
                                onClick={doLogin}
                                type="submit"
                            >
                                {loading ? "登录中..." : "登录系统"}
                            </FC.Button>
                            <div style={{ color: "#ccc", fontSize: "12px", marginTop: "10px" }}>
                                默认账号：admin / admin123
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
